import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu, expandImageUrl, isActiveExpandImageModal } from 'modules/actions/statusMenu';
import { reRenderChat } from 'modules/actions/chat';
/**
 * Image
 */
const Image = ({ boxStyle, item, viewType }) => {
  const dispatch = useDispatch();
  const { items, type, id } = item;
  const [imgState, setImgState] = useState(200);
  const ImageBox = useRef(null);

  const handleOnLoad = e => {
    setImgState(e.currentTarget.height);
    dispatch(reRenderChat());
  };

  const handleOnError = event => {
    event.currentTarget.src = 'images/noimage.png';
    event.currentTarget.className = 'errorImg';
    event.currentTarget.alt = '이미지 로드 실패';
  };

  const expandImage = url => {
    // event.currentTarget.src = 'images/noimage.png';
    // event.currentTarget.className = 'errorImg';
    // event.currentTarget.alt = '이미지 로드 실패';

    dispatch(disableAllMenu());
    dispatch(isActiveExpandImageModal(true));
    dispatch(expandImageUrl(url));
  };


  return (
    <div style={{height:`${imgState}px`}}>
      <div className="_image_div">
        {items.map((tempItem, idx) => {
          let htmlCheck = false;
          if (tempItem.image.image.includes('<img')) {
            htmlCheck = true;
          }
          return (
            <div key={`${id}_${idx}`} className="_box">
              <div
                className="_image_box"
                onClick={() => {
                  expandImage(htmlCheck ? tempItem.image.image.replace('<img src="', '').replace('"></img>', '') : tempItem[type].image);
                }}
                ref={ImageBox}
              >
                {htmlCheck ? (
                  <img src={tempItem.image.image.replace('<img src="', '').replace('"></img>', '')} alt={tempItem[type].alt} onLoad={handleOnLoad} onError={handleOnError} />
                  ) : (
                  <img src={tempItem[type].image} alt={tempItem[type].alt} onLoad={handleOnLoad} onError={handleOnError} />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
Image.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
};
Image.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
};

export default Image;
